module.exports = __webpack_public_path__ + "static/media/location.8aee61fe.svg";